import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Delete from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { withTranslation } from 'react-i18next';
import { withRouter } from "react-router-dom";
import { parseSpainFormatDate } from '../../utils/Dates';
import API from "../../utils/API";
import {getHeaderAuth} from "../../utils/Auth";

const useStyles = theme => ({
  root: {
    display: 'flex',
    margin: "5px",
    fontSize: "24px"
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 151,
    marginLeft: "auto"
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  title:{
    fontSize:"100%",
    color: 'red'
  },
  subtitle: {
    fontSize: "50%"
  },
  [theme.breakpoints.down('sm')]: {
    title: {
      fontSize: "80%"
    }
  },
  [theme.breakpoints.down('md')]: {
    title: {
      fontSize: "90%"
    }
  }
});

class Sancion extends React.Component {

  constructor(props) {
    super(props);
    this.state= {open:false, reservas: props.sancion.reservas}
    this.remove = this.remove.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOk = this.handleOk.bind(this);
  }
  
  remove(e){
    e.preventDefault();
    this.setState({open: true});
  }

  handleClose(){
    this.setState({open: false})
  }

  handleOk(){
    this.props.onDelete(this.props.sancion.id);
    this.setState({open: false});
  }

  async confirmarAsistencia(id){
    let result = await API.get('/reservas/confirmar/'+id, getHeaderAuth());
    if(result.data.status==="ok"){
      let reservas= this.state.reservas;
      for(let i=0; i<reservas.length; i++){
        if(reservas[i].id===id){
          reservas[i].reserva_confirmada=1;
        }
      }
      this.setState({reservas: reservas});
      console.log("Reserva confirmada");
    }else{
      console.log("Imposible confirmar");
      alert("No se ha podido conrirmar la reserva. "+result.data.message);
    }
  }

  
  render() {
    const { classes } = this.props;
    const { t } = this.props;
    
    return (
      <div>
      <Card className={classes.root}>
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography component="h5" variant="h5" className={classes.title}>
              {this.props.sancion.Actividade.nombre}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" className={classes.subtitle}>
            {this.props.sancion.Actividade.Instalacione.nombre}<br/>
            {t('Día inicio')}: {parseSpainFormatDate(this.props.sancion.dia_inicio)}<br/>
            {t('Día fin')}: {parseSpainFormatDate(this.props.sancion.dia_fin)}
            </Typography>
          </CardContent>
          <div className={classes.controls}>
            {this.props.onDelete && 
            <IconButton aria-label="Eliminar" onClick={this.remove}>
              <Delete />
            </IconButton>
            }
          </div>
        </div>
        <CardMedia
          className={classes.cover}
          image={process.env.PUBLIC_URL + "/images/"+this.props.sancion.Actividade.imagen}
          title="Deporte"
        />
      </Card>



      <Dialog
      open={this.state.open}
      onClose={this.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      >
      <DialogTitle id="alert-dialog-title">{t("¿Estás seguro de eliminar esta sanción?")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
        Para poder eliminar esta reserva debe confirmar al menos una asistencia de los últimos 30 días, ya que este usuario ha acumulado más de 3 ausencias en dicho periodo.
        <br/><br/>
        { this.state.reservas.map(reserva => 
          <><Button  size="small" variant="contained" color={reserva.reserva_confirmada===1?"primary":"secondary"} disabled={reserva.reserva_confirmada===1?true:false} onClick={()=>{this.confirmarAsistencia(reserva.id)}}>Confirmar asistencia {t('Día')}: {parseSpainFormatDate(reserva.fecha)} {reserva.Horario.hora_inicio.slice(0, -3)}-{reserva.Horario.hora_fin.slice(0, -3)}</Button><br/><br/></>
        )}        
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={this.handleClose} color="primary">
        {t('No eliminar')}
        </Button>
        <Button onClick={this.handleOk} color="secondary" autoFocus>
        {t('Eliminar sancion')}
        </Button>
      </DialogActions>
      </Dialog>

      </div>
    );
  }
};

export default withTranslation()(withRouter(withStyles(useStyles)(Sancion)));
